import throttle from 'lodash.throttle';

class EventScroller {
    constructor () {
        this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.customFunctions = [];
    }

    init () {
        window.addEventListener('scroll', throttle(() => {
            const lastScrollPos = window.pageYOffset;
            const scrollInfo = this.getScrollInfo(lastScrollPos);

            for (let i = 0; i < this.customFunctions.length; i++) {
                const customFunction = this.customFunctions[i];

                if (typeof customFunction === 'function') {
                    customFunction(scrollInfo);
                }
            }
        }, 100));
    }

    // helper function, which returns current scroll position and scroll direction
    // https://stackoverflow.com/questions/31223341/detecting-scroll-direction
    getScrollInfo () {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        let direction;

        if (st > this.lastScrollTop) {
            direction = 'down';
        } else {
            direction = 'up';
        }

        this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

        return {
            position: st,
            direction
        };
    }

    // helper function to check, if element is in view
    onScreen ($element, tolerance = 0, ignoreBefore = false) {
        const bounds = $element.getBoundingClientRect();

        if (ignoreBefore) {
            return (((bounds.top + tolerance) - window.innerHeight) <= 0 && bounds.bottom > 0);
        } else {
            if (bounds.top <= 0) {
                return true;
            } else {
                return (((bounds.top + tolerance) - window.innerHeight) <= 0 && bounds.bottom > 0);
            }
        }
    }
}

export { EventScroller };
